module.exports = __webpack_public_path__ + "static/media/forest.11ef260.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/forest.mp4
// module id = 1lpW
// module chunks = 1